import { TranslationKey } from './auto-generated/translation-model';

export const PaymentResponseCode = {
    ok: 'ok',
    cancel: 'cancel',
};

export const PaymentResultTypes = {
    Undefined: 0,
    // Operations
    REGISTER: 1 << 0,
    AUTH: 1 << 1,
    ACCOUNT_VERIFICATION: 1 << 2,
    SALE: 1 << 3,
    CAPTURE: 1 << 4,
    CREDIT: 1 << 5,
    ANNUL: 1 << 6,
    ADJUST_Positive: 1 << 7,
    ADJUST_Negative: 1 << 8,
    // Errorcodes
    CancelledByCustomer: 1 << 9,
    RefusedByIssuer: 1 << 10,
    RefusedByIssuerContactIssuer: 1 << 11,
    RefusedByIssuerTryAgain: 1 << 11,
    InvalidTransaction: 1 << 12,
    InvalidAmount: 1 << 13,
    IssuerCouldNotBeReached: 1 << 14,
    IssuerHasSoftDeclined: 1 << 15,
    ExpiredCard: 1 << 16,
    InvalidCardNumber: 1 << 17,
    TransactionNotFound: 1 << 18,
    InternalFailure: 1 << 19,
    TransactionAlreadyProcessed: 1 << 20,
    DeniedBy3D: 1 << 21,
    ReachedMerchantTimeout: 1 << 22,
    IssuerTimeOut: 1 << 23,
    KIDInvalidOrFieldMissingPAN: 1 << 24,
    OriginalTransactionRejected: 1 << 25,
    TransactionAlreadyReversed: 1 << 26,
    NoTransaction: 1 << 27,
    MissingCustomerInput: 1 << 28,
    // Exceptions
    GenericError: 1 << 30,
    MerchantTranslationException: 1 << 31,
    NotSupportedException: 1 << 31,
    SecurityException: 1 << 32,
    UniqueTransactionIdException: 1 << 33,
    QueryException: 1 << 34,
    ValidationException: 1 << 35,
    BBSException: 1 << 36,
    UnknownNetsException: 1 << 37, // Default in case of some unknown error

    NetsQueryServiceFailed: 1 << 40,
};

export const transactionKeys = {
    orderNo: 'orderNo',
    responseCode: 'responseCode',
    usid: 'usid',
    code: 'code',
    error: 'error',
    errorDescription: 'error_description',
    trackId: 'trackId',
};

export const getTransactionStatusTranslation = (
    response: string | undefined,
    type: number,
): TranslationKey => {
    if (response == PaymentResponseCode.cancel) {
        return 'netaxept.customerCancelled';
    } else if (response == PaymentResponseCode.ok) {
        return 'netaxept.paymentAccepted';
    }

    switch (type) {
        case PaymentResultTypes.InvalidCardNumber:
        case PaymentResultTypes.MissingCustomerInput:
        case PaymentResultTypes.InvalidAmount:
        case PaymentResultTypes.KIDInvalidOrFieldMissingPAN:
            return 'netaxept.cardIssues';
        case PaymentResultTypes.RefusedByIssuerTryAgain:
            return 'netaxept.tryAgain';
        case PaymentResultTypes.RefusedByIssuer:
        case PaymentResultTypes.OriginalTransactionRejected:
            return 'netaxept.declined';
        case PaymentResultTypes.RefusedByIssuerContactIssuer:
        case PaymentResultTypes.DeniedBy3D:
            return 'netaxept.contactIssuer';
        case PaymentResultTypes.ExpiredCard:
            return 'netaxept.noMoney';
        case PaymentResultTypes.CancelledByCustomer:
            return 'netaxept.customerCancelled';
        case PaymentResultTypes.AUTH:
            return 'netaxept.paymentAccepted';

        case PaymentResultTypes.IssuerTimeOut:
        case PaymentResultTypes.IssuerCouldNotBeReached:
        case PaymentResultTypes.ReachedMerchantTimeout:
        case PaymentResultTypes.InvalidTransaction:
        case PaymentResultTypes.TransactionNotFound:
        case PaymentResultTypes.InternalFailure:
        case PaymentResultTypes.NoTransaction:
        case PaymentResultTypes.NetsQueryServiceFailed:
        case PaymentResultTypes.GenericError:
        case PaymentResultTypes.MerchantTranslationException:
        case PaymentResultTypes.NotSupportedException:
        case PaymentResultTypes.SecurityException:
        case PaymentResultTypes.UniqueTransactionIdException:
        case PaymentResultTypes.QueryException:
        case PaymentResultTypes.ValidationException:
        case PaymentResultTypes.BBSException:
        case PaymentResultTypes.UnknownNetsException:
        default:
            return 'netaxept.tryLater';
    }
};
